<template>
    <apexchart type="area" :options="chartOptions" :series="series" height="300"></apexchart>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          },
          height: '200px',
          width: '100%',
          type: 'area',
          zoom: {
            enabled: false
          },
        },
        colors: ['#1b59f5'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        labels: [
          '2023-06-01', '2023-07-01', '2023-08-01', '2023-09-01',
          '2023-10-01', '2023-11-01'
        ], // Datas fictícias, substitua por suas reais
        xaxis: {
          type: 'datetime',
          labels: {
            formatter: function(value, timestamp) {
              const date = new Date(timestamp);
              const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
              return meses[date.getMonth()] + ' ' + date.getFullYear();
            }
          }
        },
        yaxis: {
          opposite: false
        },
        legend: {
          horizontalAlign: 'left',
          show: true
        }
      },
    }
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        if (!newData || Object.keys(newData).length === 0) {
          console.warn('Dados vazios ou indefinidos recebidos');
          return;
        }

        // Mapeamento dos meses para números
        const mesesParaNumeros = {
          janeiro: '01', fevereiro: '02', março: '03', abril: '04',
          maio: '05', junho: '06', julho: '07', agosto: '08',
          setembro: '09', outubro: '10', novembro: '11', dezembro: '12'
        };

        const anoAtual = new Date().getFullYear();

        const dadosConvertidos = Object.entries(newData).map(([mes, valor]) => {
          const numeroMes = mesesParaNumeros[mes.toLowerCase()];
          if (!numeroMes) {
            console.warn(`Mês inválido encontrado: ${mes}`);
            return null;
          }
          const data = `${anoAtual}-${numeroMes}-01`;
          return {
            x: data,
            y: valor === null ? Math.floor(Math.random() * 1000) * 1000 : valor
          };
        }).filter(item => item !== null);

        if (dadosConvertidos.length === 0) {
          console.warn('Nenhum dado válido após a conversão');
          return;
        }

        dadosConvertidos.sort((a, b) => new Date(a.x) - new Date(b.x));

        this.series = [{
          name: 'Visualizações',
          data: dadosConvertidos.map(item => item.y)
        }];

        this.chartOptions.labels = dadosConvertidos.map(item => item.x);

      }
    }
  }
}
</script>

<style>
.vue-apexcharts svg {
    width: auto;
}
</style>
